<template>
    <section>
            <form action="" @submit="save" @submit.prevent>
                <fieldset>
                    <label class="required" for="">
                        Submittal Name
                        <input type="text" placeholder="Name the submittal" required v-model="submittal.name">
                    </label>

                    <div class="actions"  v-if="!showFirstField">
                        <button @click.prevent="toggleFirstField" class="simple"><i class="fa fa-plus"></i> Add Note</button>
                    </div>
                </fieldset>

                <fieldset v-if="showFirstField">
                    <label>
                        Note
                        <textarea name="first-note" v-model="submittal.notes1"></textarea>
                        <span class="actions"></span>
                    </label>
                    <div class="actions" v-if="!showSecondField" >
                        <button @click.prevent="toggleSecondField"  class="simple">
                            <i class="fa fa-plus"></i>
                            Add Additional Note
                        </button>
                    </div>
                </fieldset>

                <fieldset v-if="showSecondField">
                    <label>
                        Note
                        <textarea name="second-note" v-model="submittal.notes2"></textarea>
                        <span class="actions"></span>
                    </label>
                </fieldset>

                <div class="confirm">
                    <div>
                        <a href="/submittal-manager" class="button back simple alternate">Projects</a>
                    </div>
                    <div>
                        <button type="submit">Save</button>
                        <button type="submit" @click="next">Next</button>
                    </div>
                </div>
            </form>
    </section>
</template>
<script>
    import information from 'vue/submittal-manager/mechanical/information/index';
    import axios from 'axios';
    import {mapActions} from 'vuex';

    export default {
        data() {
            return {
                showFirstField: false,
                showSecondField: false,
                nextPage: false,
                submittal: {
                    id: this.projectID,
                    name: '',
                    notes1: '',
                    notes2: ''
                },
            };
        },
        methods: {
            save() {

                if (this.nextPage) {

                    this
                    .createSubmittalInfo(this.submittal)
                    .then(response => {
                        this.$router.push({'name': 'mechanical-browse', params: {'submittalID': response.data.id}});
                    })
                    .catch(response => {
                        //console.log(response);
                    });

                    return;
                }

                this
                .createSubmittalInfo(this.submittal)
                .then(response => {
                    this.created = true;
                    this.$router.push({'name': 'mechanical-information', params: {'submittalID': response.data.id}});

                })
                .catch(response => {
                    //console.log(response);
                });

            },
            next() {
                this.nextPage = true;
            },
            toggleFirstField() {
                this.showFirstField = true;
            },
            toggleSecondField() {
                this.showSecondField = true;
            },
            ...mapActions('mechanical', [
                'getListOfSubmittals',
                'createSubmittalInfo',
            ]),
        },

        created() {
            this.getListOfSubmittals(this.projectID)

        },
        props: ['projectID'],
    };
</script>
